import { Link, useRoute } from 'bcms-react';
import { CenterContentContainer, ContentHeaderView, FormContainer, PageContainer, PageContentView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { PrimaryButton, SecondaryButton } from 'components/ui';
import React from 'react';
import "./styles.css";
import "./mobile.css";
import Util from 'classes/Util';

/**
 * @function FirstTimeLoginPage
 * @return {React.Component}
 * @exported true
 * @description The main component for FirstTimeLoginPage
 */

export default function FirstTimeLoginPage(props) {
  const navigate = useRoute();
  const onClick = evt => { 
    if(Util.inMabi) {
      Util.routeMabi("content/accountSummary");
    }
    else {
      navigate("/accountSummary");
    }
  }

  return(
    <PageContainer className="first-time-login">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Remember This Device" />
          <p>To help keep your account safe, we send you an alert each time someone logs into your account from an unrecognized device or browser.</p>
          <p>Click Save if you don't want to receive an alert when you login from this device again.</p>
          <FormContainer className="small-form-width">
            <FormButtonRow>
              { /** Replace Nav tags with a tags to maintain styles. Couldn't add onClick to Nav tags */}
              <a>
                <SecondaryButton text="Don't Save" onClick={ onClick }></SecondaryButton>
              </a>
              
              <a>
                <PrimaryButton text="Save" data-point="First_Time_Login_Save" onClick={ onClick }></PrimaryButton>
              </a>
            </FormButtonRow>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}